"use client";

import Image from "next/image";

export default function HomeLayout({ children }) {
  return (
    <div>
      {/* top left corner gradient image*/}
      <Image
        src="/assets/home/Looper BG.svg"
        alt="gradient"
        width={600}
        height={400}
        className="absolute inset-0 z-0 pointer-events-none"
        priority
        fetchPriority="high"
        loading="eager"
        decoding="sync"
        sizes="100vw"
        style={{
          width: '100%',
          height: '100%',
          maxWidth: '600px',
          contentVisibility: 'auto',
        }}
      />
      {/* top gradient */}
      <div 
        className="hidden mobile2:block absolute -top-[400px] left-60 w-250 h-200 rounded-full blur-[184px] z-[-1] pointer-events-none dark:bg-[#4A3467]/90 bg-[#2A40E7]/50"
        style={{ contentVisibility: 'auto' }}
      />

      {/* left top  */}
      <section className="relative -translate-y-150 mobile2:-translate-y-100 xl:translate-y-0">
        <div className="absolute top-[830px] left-[-222px] w-[412px] h-[169px] dark:bg-[#8593E8] bg-[#A1ADF5] rounded-full opacity-60 dark:opacity-20 blur-[100px]" />
        <div className="absolute top-[989px] left-[-147px] w-[417px] h-[170px] dark:bg-[#5D6EF3] bg-[#2A40E7] rounded-full opacity-40 dark:opacity-20 blur-[100px]" />
        <div className="absolute top-[1162px] left-[-246px] w-[398px] h-[163px] dark:bg-[#FC4FF6] bg-[#FF8DFB] rounded-full opacity-60 dark:opacity-20 blur-[100px]" />
      </section>

      {/* left middle */}
      <section className="relative -translate-y-170 xl:translate-y-0">
        <div className="absolute top-[2120px] left-[-180px] w-[313px] h-[272px] dark:bg-[#5D6EF3] bg-[#2A40E7] rounded-full rotate-24 opacity-40 dark:opacity-30 blur-[120px]" />
        <div className="absolute top-[2200px] left-[-50px] sm:left-[134px] w-[300px] h-[262px] dark:bg-[#FC4FF6] bg-[#FF8DFB] rounded-full rotate-26 opacity-40 dark:opacity-30 blur-[100px]" />
      </section>

      {/* right middle */}
      <section className="hidden sm:block relative xl:translate-y-0">
        <div className="absolute top-[2730px] right-[-222px] w-[271px] h-[313px] dark:bg-[#8593E8] bg-[#A1ADF5] rounded-full opacity-20 blur-[100px]" />
        <div className="absolute top-[2950px] right-[-110px] w-[274px] h-[315px] dark:bg-[#5D6EF3] bg-[#2A40E7] rounded-full opacity-20 -rotate-120 blur-[120px]" />
        <div className="absolute top-[3145px] right-[-194px] w-[262px] h-[300px] dark:bg-[#FC4FF6] bg-[#FF8DFB] rounded-full opacity-30 -rotate-120 blur-[100px]" />
      </section>

      {/* left bottom */}
      <section className="relative -translate-y-180 xl:translate-y-0">
        <div className="absolute top-[3200px] left-[-190px] w-[313px] h-[272px] dark:bg-[#5D6EF3] bg-[#2A40E7] rounded-full -rotate-126 opacity-60 dark:opacity-20 blur-[120px]" />
        <div className="absolute top-[3470px] left-[-50px] sm:left-[48px] w-[262px] h-[262px] dark:bg-[#FC4FF6] bg-[#FF8DFB] rounded-full -rotate-126 opacity-40 dark:opacity-20 blur-[80px]" />
      </section>

      <div className="">{children}</div>
    </div>
  );
}
